import {Box, Typography} from '@ttx/design-system';
import {useBreakpoint} from '@ttx/design-system/src/use-breakpoint';
import React, {useEffect, useState} from 'react';

interface NoNftProps {
  title: string;
  subtitle: string;
}

export const NoNft: React.FC<any> = ({title, subtitle}: NoNftProps) => {
  const [isMobile, setIsMobile] = useState(false);
  const {currentBreakpoint} = useBreakpoint();

  useEffect(() => {
    setIsMobile(currentBreakpoint === '768px');
  }, [currentBreakpoint]);

  return (
    <Box
      position="relative"
      overflow="hidden"
      height={isMobile ? '370px' : '500px'}
    >
      <Box flexDirection="row" position="absolute" height="100%" width="100%">
        <Box flex={1} />
        <div
          style={{
            flex: '5',
            backgroundImage: 'url(/home-page-blocks.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPositionY: 'bottom',
            backgroundPositionX: isMobile ? '0px' : '200px',
          }}
        />
      </Box>
      <Box top="50%" width="100%" backgroundColor="transparent">
        <Box marginBottom="four">
          <Typography fontSize="h2" textAlign="center" color="textDefault">
            {title}
          </Typography>
        </Box>
        <Typography textAlign="center" fontSize="s" color="textDefault">
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};
